import axios from "axios";

export default axios.create({
  baseURL: "https://text-sharer.herokuapp.com/",
  headers: {
    "Content-type": "application/json"
  }
});